import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ResolutionChart } from './ResolutionChart';
import { ResolutionStats } from './ResolutionStats';
import React from 'react';

interface ResolutionEfficiencyProps {
  data: {
    delivered: number;
    notDelivered: number;
    avgTimeDelivered: number;
    avgTimeNotDelivered: number;
  };
}

export const ResolutionEfficiency: React.FC<ResolutionEfficiencyProps> = ({
  data,
}) => {
  const total = data.delivered + data.notDelivered;
  const successRate =
    total > 0 ? Math.round((data.delivered / total) * 100) : 0;

  return (
    <div className='bg-white p-8 rounded-2xl shadow-lg border border-slate-100 flex flex-col h-full hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex justify-between items-start mb-4'>
        <h3 className='text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] flex items-center gap-2 group-hover:text-emerald-600 transition-colors'>
          <CheckCircleIcon className='!w-5 !h-5 text-emerald-500 animate-pulse' />
          Porcentaje de Entrega
        </h3>
      </div>

      <ResolutionChart
        delivered={data.delivered}
        notDelivered={data.notDelivered}
        successRate={successRate}
      />

      <ResolutionStats
        avgTimeDelivered={data.avgTimeDelivered}
        avgTimeNotDelivered={data.avgTimeNotDelivered}
      />
    </div>
  );
};
